import { createSlice } from "@reduxjs/toolkit";

const riverSlice = createSlice({
  name: "river_slice",
  initialState: {
    result: [],
    colors: "",
    inputValues: {
      pl1: "",
      pl2: "",
      pl3: "",
      pl4: "",
    },
    inputString: "",
    cards: {
      turn1: {},
      turn2: {},
      turn3: {},
      turn4: {},
      turn5: {},
    },
    disable: false,
    RangeAnalysis: [],
  },
  reducers: {
    setRiverResult: (state, { payload }) => {
      state.result = payload?.result;
      state.colors = payload?.colors;
    },
    setInputValues: (state, { payload }) => {
      state.inputValues = payload?.values;
      state.inputString = payload?.payload;
    },
    setCards: (state, { payload }) => {
      state.cards = payload;
    },
    disableCalculateButton: (state, { payload }) => {
      state.disable = true;
    },
    setRangeAnalysisResult: (state, { payload }) => {
      state.RangeAnalysis = payload;
    },
    resetRiver: (state, { payload }) => {
      state.disable = false;
      state.cards = {
        turn1: {},
        turn2: {},
        turn3: {},
        turn4: {},
        turn5: {},
      };
      state.inputValues = {
        pl1: "",
        pl2: "",
        pl3: "",
        pl4: "",
      };
      state.inputString = "";
      state.result = [];
      state.colors = [];
      state.RangeAnalysis = [];
    },
  },
});
export const {
  setRiverResult,
  setInputValues,
  setCards,
  disableCalculateButton,
  resetRiver,
  setRangeAnalysisResult,
} = riverSlice.actions;
export default riverSlice.reducer;
